import React from "react";
import { NullTranslator, Translator } from "../services/TranslationService";

export interface TranslationContextProps {
    readonly translator: Translator;

};
export const TranslationContext = React.createContext<TranslationContextProps>({
    translator: NullTranslator
});
